import { Fragment, ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { RouterLink } from 'components/Link';
import { Text } from 'components/Text/Text';

export type BreadcrumbLink = {
  'data-qa-id'?: string;
  title: ReactNode;
  to?: string;
  state?: unknown;
};

type Props = {
  'data-qa-id'?: string;
  links: Array<BreadcrumbLink>;
};

const StyledRouterLink = styled(RouterLink)`
  overflow-wrap: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export function Breadcrumbs({ links, ...props }: Props) {
  return (
    <Box
      component={Text}
      styleAs="bodySmall"
      display="flex"
      alignItems="center"
      data-qa-id="breadcrumbs"
      $whiteSpace="nowrap"
      overflow="hidden"
      $textOverflow="ellipsis"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {links.map(({ title, to, state, ...linkProps }, index) => (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          {index > 0 && (
            <Box mx={10}>
              <Icon name="chevron-left" size={11} />
            </Box>
          )}
          <Box
            component={to ? StyledRouterLink : undefined}
            // @ts-expect-error replace Box with the component
            to={to || undefined}
            state={state}
            maxWidth={[
              `calc((100% - ${31 * (links.length - 0.5)}px) / ${
                links.length - 1
              })`,
              null,
              'none',
            ]}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...linkProps}
          >
            {index < links.length - 1 ? (
              title
            ) : (
              <>
                <Box display={['none', null, 'inline']}>{title}</Box>
                <Box display={['inline', null, 'none']}>
                  <Box
                    dangerouslySetInnerHTML={{
                      __html: '&hellip;',
                    }}
                  />
                </Box>
              </>
            )}
          </Box>
        </Fragment>
      ))}
    </Box>
  );
}
